import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj:'[data-plugin="slider"]',
  init() {
    $(this.obj).slick({
      autoplay:true,
      fade: true,
      dots: true,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
  }
}

const init = () => {
  // header logo 画像差し替え
  let logo_path = ''
  const replaceLogoSrc = () => {
    if( mq.matches )  logo_path = 'header_logo.png'
    else              logo_path = 'home/header_logo.png'
    $('.p-header__logo img').attr('src', `/asset/img/${logo_path}`)
  }
  w.load['header'].then( () =>  {
    replaceLogoSrc()
    mq.addEventListener('change', replaceLogoSrc )
  })
  
  // slick実行
  w.load['mainvisual'].then( () => slider.init() )


  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="block-news-item">
        <div class="block-news-item__body">
          <span class="date">${item.date}</span>
          <span class="cate">${item.category.name}</span>
          <h4 class="subject">${item.title.str_truncate(24)}</h4>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })
}

export default function HOME() {
  $(() => init() )
}